import { fork, call, put, take, all, takeLatest } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes/header';
import config from 'config';
import apiClient from '../helpers/apiClient';

let _client = null;
function* getResource(resource, successAction, errorAction) {
    try {
        const data = yield call(async () => _client.get(resource));
        successAction.data = data;
        yield put(successAction);
    } catch (er) {
        errorAction.error = er;
        yield put(errorAction);
    }
}

function* getMainNav() {
    yield take(actionTypes.LOAD);
    yield call(getResource, config.apiPath.mainNavigation, { type: actionTypes.LOAD_NAVIGATION }, { type: actionTypes.FAIL_NAVIGATION });
}

function* getMobileNavigationData() {
    yield take(actionTypes.GET_MSITE_NAV);
    yield call(getResource, config.apiPath.mobileNavigationJsonUrl, { type: actionTypes.GET_MSITE_NAV_SUCCESS }, { type: actionTypes.GET_MSITE_NAV_FAIL });
}

function connect(requestUrl) {
    return new Promise(resolve => {
        const scriptEl = document.getElementById('unboxScript');
        if (scriptEl) {
            document.body.removeChild(scriptEl);
        }
        const script = document.createElement('script');
        script.setAttribute('id', 'unboxScript');
        script.src = requestUrl;
        document.body.appendChild(script);
        window.addEventListener('SEARCH_CALLBACK', resolve);
    });
}

function* getSearchData({ value }) {
    const successAction = { type: actionTypes.SEARCH_DATA_SUCCESS };
    // const failAction = { type: actionTypes.SEARCH_DATA_FAIL };
    const { url, siteName, APIKey, inFields, topQueries, keywordSuggestions, popularProducts } = config.searchBarConfig;
    let requestUrl = url;
    requestUrl = requestUrl.replace('{0}', `${APIKey}/${siteName}`);
    requestUrl = `${requestUrl}${value}&inFields.count=${inFields.count}&topQueries.count=${topQueries.count}&keywordSuggestions.count=${keywordSuggestions.count}&popularProducts.count=${popularProducts.count}&json.wrf=callback`;
    const result = yield call(connect, requestUrl);
    successAction.data = result.detail.response;
    yield put(successAction);
}

export function* runHeaderCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        fork(getMainNav),
        fork(getMobileNavigationData),
        takeLatest(actionTypes.SEARCH_INPUT_CHANGE, getSearchData)
    ]);
}
